import Reparto from './repartocontratacion.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/repartocontratacion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('repartocontratacion', ['ADMIN', 'INSPECTOR'], Reparto),
        keepAlive: true
    },
    {
        path: '/repartocontratacion/filter',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('repartocontratacion', ['ADMIN', 'INSPECTOR'], Reparto, { searchOnInit: true }),
        keepAlive: false
    }
];
export default routes;